/* Libre Allure (24/10/2026, demande de Séb) : aucune taille n'est cochée d'office. Tant que la cliente n'a pas choisi
   sa taille, les boutons d'achat disent « Choisis ta taille » et la ramènent au choix, et le paiement express est masqué
   (sinon un lot partait en S sans qu'elle l'ait vu). La taille par défaut reste cochée pour le sélecteur d'Horizon,
   mais ne s'affiche pas comme choisie (CSS) : seul un geste de la cliente compte. Une aide « Ta taille habituelle » coche la taille du tableau publié
   (section Guide) ; entre deux tailles, celle du dessus, comme le dit la fiche. Ce bloc passe avant les autres scripts. */
(() => {
  const TABLE = { // tableau de la section « Ta vraie taille, en centimètres » de templates/product.json
    S: ['70A', '70B', '70C', '75A', '75B'],
    M: ['75C', '80A'],
    L: ['80B', '80C', '80D', '85A', '85B'],
    XL: ['85C', '85D'],
    '2XL': ['90A', '90B', '90C', '90D', '90E'],
    '3XL': ['95A', '95B', '95C', '95D', '95E'],
  };
  const ENTRE = { '80B': ['M', 'L'], '90A': ['XL', '2XL'], '90B': ['XL', '2XL'], '90C': ['XL', '2XL'] };
  const ORDRE = ['70', '75', '80', '85', '90', '95'];
  const correspondance = {};
  Object.entries(TABLE).forEach(([t, l]) => l.forEach((fr) => { correspondance[fr] = t; }));
  let choisie = false;
  let aide = '';
  const texteBouton = 'Choisis ta taille';
  const champs = () => [...document.querySelectorAll('.la-tailles input[type="radio"]')];
  const appliquer = () => {
    if (!document.querySelector('.la-tailles')) return;
    document.body.classList.toggle('la-taille-a-choisir', !choisie);
    document.querySelectorAll('.la-libelle').forEach((s) => {
      if (!choisie) {
        if (s.textContent !== texteBouton) { s.dataset.laOrig = s.textContent; s.textContent = texteBouton; }
      } else if (s.dataset.laOrig) { s.textContent = s.dataset.laOrig; delete s.dataset.laOrig; }
    });
    poserAide();
  };
  const poserAide = () => {
    const tailles = document.querySelector('.la-tailles');
    if (!tailles || document.querySelector('.la-aide-taille')) return;
    const bloc = document.createElement('div');
    bloc.className = 'la-aide-taille';
    const options = ORDRE.map((tour) => {
      const vals = Object.keys(correspondance).filter((fr) => fr.startsWith(tour));
      return `<optgroup label="${tour}">${vals.map((fr) => `<option value="${fr}">${fr}</option>`).join('')}</optgroup>`;
    }).join('');
    bloc.innerHTML = `<label for="la-aide-select">Ta taille habituelle&nbsp;?</label>
      <select id="la-aide-select"><option value="">Par exemple 85B</option>${options}</select>
      <p class="la-aide-reponse" aria-live="polite"></p>`;
    tailles.insertAdjacentElement('beforebegin', bloc);
    const select = bloc.querySelector('select');
    const reponse = bloc.querySelector('.la-aide-reponse');
    const dire = (fr) => {
      const t = correspondance[fr];
      if (!t) { reponse.textContent = ''; return; }
      reponse.textContent = ENTRE[fr]
        ? `Pour un ${fr}, entre le ${ENTRE[fr][0]} et le ${ENTRE[fr][1]} : prends le ${t}, la taille au-dessus.`
        : `Pour un ${fr}, prends le ${t}.`;
    };
    if (aide) { select.value = aide; dire(aide); }
    ['change', 'input'].forEach((ev) => select.addEventListener(ev, (e) => {
      e.stopPropagation(); // le sélecteur de variantes d'Horizon ne doit pas voir ce menu
      if (ev !== 'change') return;
      aide = select.value; dire(aide);
      const t = correspondance[aide];
      const champ = t && champs().find((i) => i.value === t);
      if (!champ) return;
      choisie = true;
      if (!champ.checked) champ.click();
      setTimeout(appliquer, 0);
    }));
  };
  ['change', 'click'].forEach((ev) => document.addEventListener(ev, (e) => {
    if (e.isTrusted && e.target.closest && e.target.closest('.la-tailles label, .la-tailles input')) { choisie = true; setTimeout(appliquer, 0); }
  }, true));
  const bloquer = (e) => {
    if (choisie || !document.querySelector('.la-tailles')) return;
    const cible = e.type === 'submit' ? e.target : e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button');
    if (!cible) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const zone = document.querySelector('.la-aide-taille') || document.querySelector('.la-tailles');
    zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const t = document.querySelector('.la-tailles');
    t.classList.remove('la-alerte'); void t.offsetWidth; t.classList.add('la-alerte');
  };
  document.addEventListener('click', bloquer, true);
  document.addEventListener('submit', bloquer, true);
  const demarrer = () => {
    appliquer();
    const zone = document.querySelector('.product-information') || document.body;
    let t = 0;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(appliquer, 30); }).observe(zone, { subtree: true, childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Libre Allure : les boutons des sections (data-la-palier) reprennent le libellé du bouton d'achat
   (« Je prends mes 3 · 69,98 € ») et suivent le palier choisi dans le sélecteur. */
(() => {
  const maj = () => {
    const source = document.querySelector('product-form-component .la-libelle');
    if (!source) return;
    const texte = source.textContent.trim();
    document.querySelectorAll('[data-la-palier]').forEach((lien) => {
      if (lien.textContent.trim() !== texte) lien.textContent = texte;
    });
  };
  const demarrer = () => {
    maj();
    const zone = document.querySelector('.product-information');
    if (zone) new MutationObserver(maj).observe(zone, { subtree: true, childList: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Libre Allure (audit du 21/10/2026) : sur mobile, le bouton d'achat est sous le premier écran. Tant qu'il est plus bas
   que l'écran, une barre fixe reprend son libellé et descend au choix de la taille ; la barre native d'Horizon prend
   le relais une fois le bouton dépassé. Jamais deux boutons à l'écran. */
(() => {
  const demarrer = () => {
    const achat = document.querySelector('.product-information .buy-buttons-block');
    const tailles = document.querySelector('.la-tailles') || document.querySelector('.la-picker');
    if (!achat || !tailles || document.querySelector('.la-barre-arrivee')) return;
    const source = document.querySelector('product-form-component .la-libelle');
    const barre = document.createElement('div');
    barre.className = 'la-barre-arrivee';
    barre.innerHTML = '<button type="button" class="button"></button>';
    const bouton = barre.querySelector('button');
    const libelle = () => { bouton.textContent = source ? source.textContent.trim() : 'Choisir ma taille'; };
    libelle();
    if (source) new MutationObserver(libelle).observe(source, { subtree: true, childList: true, characterData: true });
    bouton.addEventListener('click', () => {
      window.scrollTo({ top: tailles.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    });
    document.body.appendChild(barre);
    const maj = () => barre.classList.toggle('la-visible', achat.getBoundingClientRect().top > window.innerHeight - 8);
    window.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Libre Allure (22/10/2026) : quand la cliente ajoute 1 seul soutien-gorge, une petite fenêtre lui propose le lot de 3
   (le 3e offert), une seule fois par visite. « Oui » passe sur l'offre de 3 puis ajoute ; « Non merci » ajoute 1 pièce.
   Aucun compte à rebours, aucun prix inventé : les prix sont lus dans le sélecteur d'offres. */
(() => {
  const CLE = 'la-proposition-3-vue';
  let passe = false;
  let vue = false;
  try { vue = sessionStorage.getItem(CLE) === '1'; } catch (e) {}
  const marquer = () => { vue = true; try { sessionStorage.setItem(CLE, '1'); } catch (e) {} };
  const prix = (texte) => parseFloat(String(texte || '').replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;
  const euros = (n) => n.toFixed(2).replace('.', ',') + ' €';
  const offre = (n) => [...document.querySelectorAll('.la-offres .la-offre')].find((l) => l.style.order === String(n));
  const choisie = () => {
    const coche = document.querySelector('.la-offres input[type="radio"]:checked');
    return coche ? parseInt(coche.value, 10) : 0;
  };
  const bouton = () => document.querySelector('product-form-component button[name="add"]');

  const ajouter = () => { passe = true; const b = bouton(); if (b) b.click(); passe = false; };

  const proposer = () => {
    const un = offre(1), trois = offre(3);
    if (!un || !trois) return false;
    const p1 = prix(un.querySelector('.la-combien')?.textContent);
    const p3 = prix(trois.querySelector('.la-total')?.textContent);
    if (!p1 || !p3) return false;
    marquer();
    const fond = document.createElement('div');
    fond.className = 'la-proposition';
    fond.innerHTML = `
      <div class="la-proposition__carte" role="dialog" aria-modal="true" aria-labelledby="la-proposition-titre">
        <button type="button" class="la-proposition__fermer" aria-label="Fermer">×</button>
        <p class="la-proposition__titre" id="la-proposition-titre">Le 3e est offert</p>
        <p class="la-proposition__texte">Pour ${euros(p3 - p1)} de plus, tu en reçois 3 dans ta taille au lieu d'un. Ça fait ${euros(p3 / 3)} la pièce.</p>
        <button type="button" class="button la-proposition__oui">Oui, j'en prends 3</button>
        <button type="button" class="la-proposition__non">Non merci, juste 1</button>
      </div>`;
    const fermer = () => { fond.remove(); document.removeEventListener('keydown', echap); };
    const echap = (e) => { if (e.key === 'Escape') fermer(); };
    fond.addEventListener('click', (e) => { if (e.target === fond) fermer(); });
    fond.querySelector('.la-proposition__fermer').addEventListener('click', fermer);
    fond.querySelector('.la-proposition__non').addEventListener('click', () => { fermer(); ajouter(); });
    fond.querySelector('.la-proposition__oui').addEventListener('click', () => {
      fermer();
      const champ = document.querySelector('product-form-component input[name="id"]');
      const avant = champ ? champ.value : '';
      trois.querySelector('input')?.click();
      const debut = Date.now();
      const attendre = () => {
        const c = document.querySelector('product-form-component input[name="id"]');
        const b = bouton();
        const pret = c && c.value !== avant && b && !b.disabled && choisie() === 3;
        if (pret) ajouter();
        else if (Date.now() - debut < 5000) setTimeout(attendre, 120);
        else trois.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      setTimeout(attendre, 150);
    });
    document.addEventListener('keydown', echap);
    document.body.appendChild(fond);
    fond.querySelector('.la-proposition__oui').focus();
    return true;
  };

  const intercepter = (e) => {
    if (passe || vue) return;
    const cible = e.type === 'submit' ? e.target : e.target.closest && e.target.closest('button[name="add"]');
    if (!cible || !cible.closest('product-form-component')) return;
    if (choisie() !== 1) return;
    if (proposer()) { e.preventDefault(); e.stopImmediatePropagation(); }
  };
  document.addEventListener('click', intercepter, true);
  document.addEventListener('submit', intercepter, true);
})();

/* Libre Allure (22/10/2026) : les vidéos des sections ne se téléchargent qu'à l'approche de l'écran,
   pour laisser la photo du haut s'afficher d'abord sur mobile. */
(() => {
  const demarrer = () => {
    const videos = document.querySelectorAll('video.la-video-differee');
    if (!videos.length) return;
    const lancer = (v) => { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    if (!('IntersectionObserver' in window)) { videos.forEach(lancer); return; }
    const obs = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => { if (e.isIntersecting) lancer(e.target); else if (!e.target.paused) e.target.pause(); });
    }, { rootMargin: '300px 0px' });
    videos.forEach((v) => obs.observe(v));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();

/* Libre Allure (22/10/2026) : dans les lots de 3 et de 5, la cliente choisit une couleur par pièce.
   Chaque pièce part au panier comme un article à l'unité (DSers l'envoie avec sa couleur) ; la remise automatique
   « Le 3e offert » ou « 5 pour le prix de 3 » ramène le total au prix du lot. Sans JavaScript, le lot part en une couleur. */
(() => {
  let carte = null;
  let pieces = [];
  let passe = false;
  let enCours = false;

  const lireCarte = () => {
    const el = document.getElementById('la-variantes');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };
  const nbPieces = () => {
    const c = document.querySelector('.la-offres input[type="radio"]:checked');
    return c ? parseInt(c.value, 10) || 0 : 0;
  };
  const couleurPrincipale = () => {
    const c = document.querySelector('.la-couleurs input[type="radio"]:checked');
    return c ? c.value : (carte && carte.teintes[0] ? carte.teintes[0][0] : '');
  };
  const taille = () => {
    const c = document.querySelector('.la-tailles input[type="radio"]:checked');
    return c ? c.value : '';
  };
  const variante = (couleur) => {
    if (!carte) return null;
    const v = carte.variantes.find((x) => parseInt(x[1][carte.offre], 10) === 1 && x[1][carte.couleur] === couleur && x[1][carte.taille] === taille());
    return v ? { id: v[0], dispo: v[2] } : null;
  };

  const bloc = () => {
    const n = nbPieces();
    const div = document.createElement('div');
    div.className = 'la-mix';
    div.innerHTML = `<p class="la-mix__titre">Tes ${n} couleurs <span>· mélange comme tu veux</span></p>` +
      pieces.slice(0, n).map((c, i) => `
        <div class="la-mix__ligne" role="radiogroup" aria-label="Couleur de la pièce ${i + 1}">
          <span class="la-mix__num">${i + 1}</span>
          ${carte.teintes.map(([nom, teinte]) => `
            <button type="button" class="la-mix__pastille" role="radio" aria-checked="${nom === c}" aria-label="${nom}" title="${nom}" data-piece="${i}" data-couleur="${nom}">
              <i style="background:${teinte}"></i>
            </button>`).join('')}
          <span class="la-mix__nom">${c}</span>
        </div>`).join('');
    div.addEventListener('click', (e) => {
      const b = e.target.closest('.la-mix__pastille');
      if (!b) return;
      pieces[parseInt(b.dataset.piece, 10)] = b.dataset.couleur;
      maj(true);
    });
    return div;
  };

  let obs = null;
  const maj = (force) => {
    const picker = document.querySelector('.la-picker');
    const offres = document.querySelector('.la-offres');
    if (!picker || !offres || !carte) return;
    const n = nbPieces();
    if (obs) obs.disconnect();
    const existant = document.querySelector('.la-mix');
    if (n > 1) {
      while (pieces.length < n) pieces.push(pieces.length ? pieces[pieces.length - 1] : couleurPrincipale());
      picker.classList.add('la-mix-actif');
      const ancre = document.querySelector('.la-couleurs') || offres;
      const sig = n + '|' + pieces.slice(0, n).join(',');
      if (force || !existant || existant.dataset.sig !== sig || existant.previousElementSibling !== ancre) {
        const nouveau = bloc();
        nouveau.dataset.sig = sig;
        if (existant) existant.remove();
        ancre.insertAdjacentElement('afterend', nouveau);
      }
    } else {
      picker.classList.remove('la-mix-actif');
      if (existant) existant.remove();
      pieces = [];
    }
    if (obs) obs.observe(document.querySelector('.product-information') || document.body, { subtree: true, childList: true });
  };

  const ajouter = async (e) => {
    if (passe) return;
    const cible = e.type === 'submit' ? e.target : e.target.closest && e.target.closest('button[name="add"]');
    if (!cible || !cible.closest('product-form-component')) return;
    const n = nbPieces();
    if (n < 2 || !carte) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (enCours) return;
    const liste = pieces.slice(0, n).map((c) => variante(c));
    if (liste.some((v) => !v || !v.dispo)) {
      alert('Cette couleur n’est plus disponible dans ta taille. Choisis-en une autre.');
      return;
    }
    enCours = true;
    try {
      const derniere = liste.pop();
      const compte = {};
      liste.forEach((v) => { compte[v.id] = (compte[v.id] || 0) + 1; });
      const items = Object.entries(compte).map(([id, quantity]) => ({ id: Number(id), quantity }));
      if (items.length) {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error('ajout');
      }
      const form = document.querySelector('product-form-component form');
      const champ = form && form.querySelector('input[name="id"]');
      const qte = form && form.querySelector('input[name="quantity"]');
      if (!champ) throw new Error('formulaire');
      champ.value = String(derniere.id);
      if (qte) qte.value = '1';
      passe = true;
      document.querySelector('product-form-component button[name="add"]').click();
    } catch (err) {
      alert('L’ajout au panier n’a pas marché. Réessaie dans un instant.');
    } finally {
      passe = false;
      enCours = false;
    }
  };

  const demarrer = () => {
    carte = lireCarte();
    if (!carte) return;
    obs = new MutationObserver(() => { clearTimeout(obs.t); obs.t = setTimeout(() => maj(false), 60); });
    maj(false);
    document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('.la-offres, .la-tailles')) setTimeout(() => maj(false), 0); });
    document.addEventListener('click', ajouter, true);
    document.addEventListener('submit', ajouter, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
